import { Call } from '@jive/realtime-events';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppAction } from '../actions/actionCreators';
import { updateActiveCall } from '../calls/callEvents.action';
import {
  callSelector,
  getContactDisplayFromCall,
  getContactMatchTypeSelector,
  isContactMatchingLoadingForCallSelector,
} from '../calls/calls.selector';
import { AppState } from '../reducers';
import { currentIntegrationSelector } from '../integrations/integrations.selector';
import {
  CallInformationSnackBarMessageDispatchProps,
  CallInformationSnackBarMessageOwnProps,
  CallInformationSnackBarMessageStateProps,
  ScreenPopComponent,
} from './ScreenPop.component';
import { CallWithDuration } from '../calls/calls.reducer';

const mapState = (state: AppState, { callId }): CallInformationSnackBarMessageStateProps => ({
  call: callSelector(state, callId) as CallWithDuration,
  isContactMatchingInProgress: isContactMatchingLoadingForCallSelector(state, callId),
  contactDisplayFromCall: getContactDisplayFromCall(state, callId),
  matchType: getContactMatchTypeSelector(state, callId),
  currentIntegration: currentIntegrationSelector(state),
});

const mapDispatch = (dispatch: Dispatch<AppAction>, { onClose }): CallInformationSnackBarMessageDispatchProps => ({
  updateActiveCall: (call: Call) => dispatch(updateActiveCall({ call })),
  onClose,
});

export const ScreenPop = connect<
  CallInformationSnackBarMessageStateProps,
  CallInformationSnackBarMessageDispatchProps,
  CallInformationSnackBarMessageOwnProps,
  AppState
>(
  mapState,
  mapDispatch,
)(ScreenPopComponent);
